import { hydrateRoot } from 'react-dom/client';
import { SiteApp } from './App';
import './styles.css';

document.documentElement.classList.add('js');
const root = document.getElementById('root');
if (!root) throw new Error('Root element is missing');
hydrateRoot(root, <SiteApp path={window.location.pathname} />, {
  onRecoverableError(error) {
    throw error;
  },
});
